
import axios from 'axios';
import { CampaignModel, CustomerGroupModel, CustomerModel, CustomerUserModel, ISettingRequestParams, RouteLine, RouteModel, SegmentCustomerModel, SegmentModel, SegmentProductGroupModel, SegmentProductModel } from '../types/crm-contact';
import { getAppToken, getVendorId } from './sessions';
import { appInfo } from '../app-info';
import i18next from 'i18next';

// login isteği

const apiUrl = appInfo().apiURL;
const newUrl = "https://routeadmin.mobiapi.net";

export async function loginFromMobiserver(userName, password, vendor) {
  //var passwordHash = await hashPasswordUTF16LEHex(password);
  var request = await axios.post("https://admin.mobiapi.de", {
    "serviceId": "9991",
    "vendorId": vendor,
    "userName": userName,
    "password": password,
    "productCode": "15",
    "lang": i18next.language ?? "en",
  }, {
    headers: {
      Authorization: "Basic U2FsdGVkX1+oBz5nKYWkJPAEDHjsJz9LZnfTffxUEAQIl65EZbmqZ0rCyprId6Zhx6saFGMpv3wWQqrtd/RZ7w==",
    },
  });
  return request.data;
}

export async function sendToken(userRef, apiToken, vendor) {
  var request = await axios.post(newUrl, {
    "serviceId": "5252",
    "vendorId": vendor,
    "userRef": userRef,
    "productCode": "15",
    "lang": i18next.language ?? "en",
    "apiToken": apiToken
  }, {
    headers: {
      Authorization: "Basic U2FsdGVkX1+oBz5nKYWkJPAEDHjsJz9LZnfTffxUEAQIl65EZbmqZ0rCyprId6Zhx6saFGMpv3wWQqrtd/RZ7w==",
    },
  });
  return request.data;
}
export async function sendTokenFBS(userRef, apiToken, vendor) {
  var request = await axios.post(apiUrl, {
    "serviceId": "5252",
    "vendorId": vendor,
    "userRef": userRef,
    "productCode": "15",
    "lang": i18next.language ?? "en",
    "apiToken": apiToken
  });
  return request.data;
}

export async function loginRequest(userName: string, password: string, vendorId: string) {
  var request = await axios.post(apiUrl, {
    serviceId: '1515',
    vendorId: vendorId,
    userName: userName,
    password: password,
    lang: "tr",
    deviceManifacturer: "",
    deviceModel: "",
    deviceSerial: "",
    deviceOSName: "",
    deviceOSVersion: "",
  },);
  return request;
}


// tüm müşteriler isteği

export async function customersRequest(status) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '1020',
    vendorId: appVendorID,
    token: appToken,
    customerActive: status ?? 1
  });
  return request.data;
}



// müşterinin tüm kullancıları isteği

export async function customerUsersRequest(customerRef: number) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1030",
    vendorId: appVendorID,
    token: appToken,
    customerRef: customerRef,
  },);
  return request;
}


// kullanıcının tüm müşterileri isteği

export async function usersCustomersListRequest(shopUserRef: number) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1035",
    vendorId: appVendorID,
    token: appToken,
    shopUserRef: shopUserRef,
  },);
  return request.data;
}



// müşteri grubu ekle

export async function customerGroupUpdateRequest(customerGroup: CustomerGroupModel) {
  var appVendorID = getVendorId();
  var appToken = getAppToken();
  var request = await axios.post(
    apiUrl,
    {
      serviceId: "1041",
      vendorId: appVendorID,
      token: appToken,
      customerGroupRef: customerGroup.customerGroupRef,
      productGroupRef: customerGroup.productGroupRef,
      customerActive: customerGroup.customerActive,
      customerGroupCode: customerGroup.customerGroupCode,
      customerGroupName: customerGroup.customerGroupName,
      erpFirmNr: customerGroup.erpFirmNr,
      erpBranch: customerGroup.erpBranch,
      erpWarehouse: customerGroup.erpWarehouse,
      erpSalesManCode: customerGroup.erpSalesManCode,
      comment: customerGroup.comment
    },
  );
  return request.data;
}

// müşteri grubu sil

export async function customerGroupDeleteRequest(customerGroup: CustomerGroupModel) {
  var appVendorID = getVendorId();
  var appToken = getAppToken();
  var request = await axios.post(
    apiUrl,
    {
      serviceId: "1041",
      vendorId: appVendorID,
      token: appToken,
      customerGroupRef: customerGroup.customerGroupRef,
      productGroupRef: customerGroup.productGroupRef,
      customerActive: 2,
      customerGroupCode: customerGroup.customerGroupCode,
      customerGroupName: customerGroup.customerGroupName,
      erpFirmNr: customerGroup.erpFirmNr,
      erpBranch: customerGroup.erpBranch,
      erpWarehouse: customerGroup.erpWarehouse,
      erpSalesManCode: customerGroup.erpSalesManCode,
      comment: customerGroup.comment
    },
  );
  return request.data;
}


// müşteri güncelle

export async function customerUpdateRequest(
  customerRef: number,
  customerActive: number,
  customerCode: string,
  customerName: string,
  customerGroupRef: number,
  erpCustomerRef: number,
  erpShippingAdrRef: number,
  productGroupRef: number,
  segmentRef: number
) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();

  var request = await axios.post(
    apiUrl,
    {
      serviceId: "1021",
      vendorId: appVendorID,
      token: appToken,
      customerRef: customerRef,
      customerActive: customerActive,
      customerCode: customerCode,
      customerName: customerName,
      customerGroupRef: customerGroupRef,
      erpCustomerRef: erpCustomerRef,
      erpShippingAdrRef: erpShippingAdrRef,
      productGroupRef: productGroupRef,
      segmentRef: segmentRef
    },
  );
  return request.data;
}


// müşteri toplu güncelle güncelle

export async function customerUpdateStatusRequest(customer: CustomerModel, status) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();

  var request = await axios.post(
    apiUrl,
    {
      serviceId: "1021",
      vendorId: appVendorID,
      token: appToken,
      customerRef: customer.customerRef,
      customerActive: status,
      customerCode: customer.customerCode,
      customerName: customer.customerName,
      customerGroupRef: customer.customerGroupRef,
      erpCustomerRef: customer.erpCustomerRef,
      erpShippingAdrRef: customer.erpShippingAdrRef,
      productGroupRef: customer.productGroupRef
    },
  );
  return request.data;
}


//yeni customerUser ekle

export async function customerUserUpdateRequest(model: CustomerUserModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(
    apiUrl,
    {
      serviceId: "1031",
      vendorId: appVendorID,
      token: appToken,
      comment: model.comment,
      customerRef: model.customerRef,
      customerUserRef: model.customerUserRef,
      userRef: model.userRef,
      userActive: model.userActive,
      userName: model.userName,
      userEmail: model.userEmail,
      userPassword: model.userPassword,

    }
  );
  return request.data;
}

// USERS tüm kullancılar isteği

export async function b2bUsersListRequest(customerRef, status) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1025",
    vendorId: appVendorID,
    token: appToken,
    customerRef: customerRef,
    userStatus: status
  },);
  return request.data;
}

// USERS add user isteği

export async function b2bUsersListUpdateRequest(user: CustomerUserModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1026",
    vendorId: appVendorID,
    token: appToken,
    "customerUserRef": 0,
    "customerRef": 0,
    "customerUserActive": 0,
    "customerUserComment": "",
    "shopUserRef": user.userRef,
    "shopUserActive": user.userActive,
    "shopUserName": user.userName,
    "shopUserEmail": user.userEmail,
    "shopUserPassword": user.userPassword,
    "shopUserComment": user.comment,
    "linkCustomer": 0
  },);
  return request.data;
}

// USERS toplu status update

export async function b2bUsersStatusUpdateRequest(user: CustomerUserModel, status) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1026",
    vendorId: appVendorID,
    token: appToken,
    "customerUserRef": 0,
    "customerRef": 0,
    "customerUserActive": 0,
    "customerUserComment": "",
    "shopUserRef": user.userRef,
    "shopUserActive": status,
    "shopUserName": user.userName,
    "shopUserEmail": user.userEmail,
    "shopUserPassword": user.userPassword,
    "shopUserComment": user.comment,
    "linkCustomer": 0
  },);
  return request.data;
}

// USERS add user isteği

export async function b2bUsersListDeleteRequest(user: CustomerUserModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1026",
    vendorId: appVendorID,
    token: appToken,
    "customerUserRef": 0,
    "customerRef": 0,
    "customerUserActive": 0,
    "customerUserComment": "",
    "shopUserRef": user.userRef,
    "shopUserActive": 2,
    "shopUserName": user.userName,
    "shopUserEmail": user.userEmail,
    "shopUserPassword": user.userPassword,
    "shopUserComment": user.comment,
    "linkCustomer": 0
  },);
  return request.data;
}

// USERS add user with customer isteği

export async function b2bUsersListUpdateWithCustomerRequest(user: CustomerUserModel, customer: CustomerUserModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1026",
    vendorId: appVendorID,
    token: appToken,
    "customerUserRef": 0,
    "customerRef": customer.customerRef,
    "customerUserActive": 1,
    "customerUserComment": customer.comment,
    "shopUserRef": 0,
    "shopUserActive": user.userActive,
    "shopUserName": user.userName,
    "shopUserEmail": user.userEmail,
    "shopUserPassword": user.userPassword,
    "shopUserComment": user.comment,
    "linkCustomer": 1
  },);
  return request.data;
}
// Customer delete user with user isteği

export async function b2bUsersListDeleteWithCustomerRequest(user: CustomerUserModel, customer: CustomerUserModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1026",
    vendorId: appVendorID,
    token: appToken,
    "customerUserRef": customer.customerUserRef,
    "customerRef": customer.customerRef,
    "customerUserActive": 2,
    "customerUserComment": customer.comment,
    "shopUserRef": user.userRef,
    "shopUserActive": user.userActive,
    "shopUserName": user.userName,
    "shopUserEmail": user.userEmail,
    "shopUserPassword": user.userPassword,
    "shopUserComment": user.comment,
    "linkCustomer": 1
  },);
  return request.data;
}
// Customer delete user with user isteği

export async function b2bUsersListDeleteWithCustomerRequest2(user: CustomerUserModel, customer: CustomerUserModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1026",
    vendorId: appVendorID,
    token: appToken,
    "customerUserRef": user.customerUserRef,
    "customerRef": customer.customerRef,
    "customerUserActive": 2,
    "customerUserComment": customer.comment,
    "shopUserRef": user.userRef,
    "shopUserActive": user.userActive,
    "shopUserName": user.userName,
    "shopUserEmail": user.userEmail,
    "shopUserPassword": user.userPassword,
    "shopUserComment": user.comment,
    "linkCustomer": 1
  },);
  return request.data;
}

export async function b2bUsersListUpdateWithCustomerRequest2(user: CustomerUserModel, customer: CustomerUserModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: "1026",
    vendorId: appVendorID,
    token: appToken,
    "customerUserRef": 0,
    "customerRef": customer.customerRef,
    "customerUserActive": 1,
    "customerUserComment": customer.comment,
    "shopUserRef": user.userRef,
    "shopUserActive": user.userActive,
    "shopUserName": user.userName,
    "shopUserEmail": user.userEmail,
    "shopUserPassword": user.userPassword,
    "shopUserComment": user.comment,
    "linkCustomer": 1
  },);
  return request.data;
}


//exports list

export async function exportsListRequest(beginDate, endDate, docType) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(
    apiUrl,
    {
      serviceId: "5020",
      vendorId: appVendorID,
      token: appToken,
      beginDate: beginDate,
      endDate: endDate,
      docType: docType

    }
  );
  return request.data;
}


// dashboard1

export async function dashboard1(begin, end) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(
    apiUrl,
    {
      serviceId: "5051",
      vendorId: appVendorID,
      token: appToken,
      beginDate: begin,
      endDate: end
    }
  );
  return request.data;
}




// dashboard2

export async function dashboard2Request(index) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(
    apiUrl,
    {
      serviceId: "5050",
      vendorId: appVendorID,
      token: appToken,
      dashboardIndex: index
    }
  );
  return request.data;
}



// dashboard3

export async function dashboard3Request(index) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(
    apiUrl,
    {
      serviceId: "5052",
      vendorId: appVendorID,
      token: appToken,
      dashboardIndex: index
    }
  );
  return request.data;
}



// müşteri grupları isteği

export async function customerGroupsRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '1040',
    vendorId: appVendorID,
    token: appToken,
  });
  return request;
}

// Sales/Routes isteği

export async function salesRoutesRequest(beginDate, endDate) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5002',
    vendorId: appVendorID,
    token: appToken,
    beginDate: beginDate,
    endDate: endDate
  });
  return request.data;
}



// Sales/Routes UPDATE isteği

export async function salesRoutesUpdateRequest(route: RouteModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5003',
    vendorId: appVendorID,
    token: appToken,
    routeRef: route.routeRef,
    routeActive: route.routeActive,
    routeStatus: route.routeStatus,
    routeCode: route.routeCode,
    routeName: route.routeName,
    routePlanRef: route.routePlanRef,
    erpSlsManRef: route.erpSlsManRef,
    erpSlsManCode: route.erpSlsManCode,
    erpVehicleRef: route.erpVehicleRef,
    routeDate: route.routeDate,
    comment: route.comment
  });
  return request.data;
}


// Sales/Routes DELETE isteği

export async function salesRoutesDeleteRequest(route: RouteModel) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5003',
    vendorId: appVendorID,
    token: appToken,
    routeRef: route.routeRef,
    routeActive: 2,
    routeStatus: route.routeStatus,
    routeCode: route.routeCode,
    routeName: route.routeName,
    routePlanRef: route.routePlanRef,
    erpSlsManRef: route.erpSlsManRef,
    erpSlsManCode: route.erpSlsManCode,
    erpVehicleRef: route.erpVehicleRef,
    routeDate: route.routeDate,
    comment: route.comment
  });
  return request.data;
}


// Sales/Route Lines List isteği

export async function salesRouteLineListRequest(routeRef) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5004',
    vendorId: appVendorID,
    token: appToken,
    routeRef: routeRef
  });
  return request.data;
}


// Sales/Route Lines UPDATE isteği

export async function salesRouteLineUpdateRequest(routeLine) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5005',
    vendorId: appVendorID,
    token: appToken,
    routeRef: routeLine.routeRef,
    routeLineRef: routeLine.routeLineRef,
    //  routeLineActive: routeLine.routeLineActive,
    routeLineType: routeLine.routeLineType,
    //   routeLineNr: routeLine.routeLineNr,
    erpCustomerRef: routeLine.erpCustomerRef,
    //   erpCustomerCode: routeLine.erpCustomerCode,
    //   erpCustomerName: routeLine.erpCustomerName,
    //   erpCustomerAdr: routeLine.erpCustomerAdr,
    //   erpShipInfoRef: routeLine.erpShipInfoRef,
    //   erpShippingAdr: routeLine.erpShippingAdr,
    erpShippingAdrRef: routeLine.erpShippingAdrRef,
    //    formLineRef: routeLine.formLineRef,
    routeLineStatus: routeLine.routeLineStatus,
    //    beginDate: routeLine.beginDate,
    //   endDate: routeLine.endDate,
    newRouteLineNr: routeLine.newRouteLineNr ?? routeLine.routeLineNr,
    routeLineCloseReasonRef: 0,
    routeLineActive: routeLine.routeLineActive,
    comment: routeLine.comment
  });
  return request.data;
}

// Sales/Route Lines INSERT isteği

export async function salesRouteLineInsertRequest(route, customer) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5005',
    vendorId: appVendorID,
    token: appToken,
    routeRef: route.routeRef,
    routeLineRef: 0,
    routeLineType: 0,
    erpCustomerRef: customer.erpCustomerRef,
    erpShippingAdrRef: customer.erpShippingAdrRef,
    routeLineStatus: 0,
    routeLineActive: 1,
    newRouteLineNr: 0,
    routeLineCloseReasonRef: 0,
    comment: ""
  });
  return request.data;
}

// Sales/Route Lines DELETE isteği

export async function salesRouteLineDeleteRequest(routeLine) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5005',
    vendorId: appVendorID,
    token: appToken,
    routeRef: routeLine.routeRef,
    routeLineRef: routeLine.routeLineRef,
    routeLineType: routeLine.routeLineType,
    erpCustomerRef: routeLine.erpCustomerRef,
    erpShippingAdrRef: routeLine.erpShippingAdrRef,
    routeLineActive: 2,
    routeLineStatus: routeLine.routeLineStatus,
    newRouteLineNr: 0,
    routeLineCloseReasonRef: 0,
    comment: ""
  });
  return request.data;
}


// Sales/Route Customer Search isteği

export async function routeCustomerSearchRequest(routeRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5006',
    vendorId: appVendorID,
    token: appToken,
    routeRef: routeRef
  });
  return request.data;
}


// Sales/Salesman List isteği

export async function salesUserRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5000',
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}

// Sales/Salesman-Customers isteği

export async function salesmanCustomersListRequest(salesman) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5007',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,
  });
  return request.data;
}

// Sales/Salesman-Customers Search isteği

export async function salesmanCustomersSearchRequest(salesman) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5009',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,
  });
  return request.data;
}

// Sales/Salesman-Customer Add isteği

export async function salesmanCustomerAddRequest(salesman, erpCustomerRef, salesmanCustomerRef, shippingAdrRef, status) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5008',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,
    salesmanCustomerRef: salesmanCustomerRef,
    erpCustomerRef: erpCustomerRef,
    erpShippingAdrRef: shippingAdrRef,
    lineNr: 0,
    beginDate: "",
    visitDay: 0,
    visitPeriod: 0,
    comment: "",
    salesmanCustomerStatus: status
  });
  return request.data;
}

export async function salesmanCustomerUpdateRequest(salesman, customer) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5008',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,
    salesmanCustomerRef: customer.salesmanCustomerRef,
    erpCustomerRef: customer.erpCustomerRef,
    erpShippingAdrRef: customer.erpShipInfoRef,
    lineNr: 0,
    beginDate: customer.beginDate,
    visitDay: customer.visitDay,
    visitPeriod: customer.visitPeriod,
    comment: "",
    salesmanCustomerStatus: 1
  });
  return request.data;
}


// Sales/Salesman Edit İsteği

export async function salesUserUpdateRequest(salesman) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();

  var request = await axios.post(
    apiUrl,
    {
      serviceId: "5001",
      vendorId: appVendorID,
      token: appToken,

      salesManRef: salesman.salesManRef,
      salesManActive: salesman.salesManActive,
      salesManName: salesman.salesManName,
      salesManEMail: salesman.salesManEMail,
      salesManPassword: salesman.salesManPassword,
      // erpSlsManRef: salesman.erpSlsManRef,
      erpSlsManCode: salesman.erpSlsManCode,
      // erpSlsManName1: salesman.erpSlsManName1,
      erpFirmNr: salesman.erpFirmNr,
      erpBranch: salesman.erpBranch,
      erpWHCentral: salesman.erpWHCentral,
      erpWHReturn: salesman.erpWHReturn,
      erpWHScrap: salesman.erpWHScrap,
      erpCashBoxCode: salesman.erpCashBoxCode,
      erpDiscLimit: salesman.erpDiscLimit,
      erpSalesOrderStatus: salesman.erpSalesOrderStatus,
      rightSalesOrder: salesman.rightSalesOrder,
      rightSalesDispatch: salesman.rightSalesDispatch,
      rightSalesDispatchRt: salesman.rightSalesDispatchRt,
      rightSalesInvoice: salesman.rightSalesInvoice,
      rightSalesInvoiceRt: salesman.rightSalesInvoiceRt,
      rightPaymentCash: salesman.rightPaymentCash,
      rightGetPdf: salesman.rightGetPdf,
      rightGetAllProducts: salesman.rightGetAllProducts,
      rightGetAllProductGroups: salesman.rightGetAllProductGroups,
      rightGetAllProductSubCategories: salesman.rightGetAllProductSubCategories,
      routeActive: salesman.routeActive,
      routeChangeDataAfterSave: salesman.routeChangeDataAfterSave,
      routeSendDataAfterSave: salesman.routeSendDataAfterSave,
      comment: salesman.comment,

    },
  );
  return request.data;
}
export async function salesmanProductGroupDeleteRequest(salesman,salesmanProductCategoryRef,itemCategory) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5011',
    vendorId: appVendorID,
    token: appToken,
    salesmanProductCategoryRef: salesmanProductCategoryRef,
    salesmanRef: salesman.salesManRef,
    productCategoryCode:itemCategory,
    comment: "",
    delete: 1
  });
  return request.data;
}


//salesmanProductGroupAddRequest
export async function salesmanProductGroupAddRequest(salesman,salesmanProductCategoryRef,itemCategory) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5011',
    vendorId: appVendorID,
    token: appToken,
    salesmanProductCategoryRef: salesmanProductCategoryRef,
    salesmanRef: salesman.salesManRef,
    productCategoryCode:itemCategory,
    comment: "",
    delete: 0
  });
  return request.data;
}

export async function salesmanProductGroupUpdateRequest(salesman,updatedData) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5011',
    vendorId: appVendorID,
    token: appToken,
    salesmanProductCategoryRef: updatedData.salesmanProductCategoryRef,
    salesmanRef: salesman.salesManRef,
    productCategoryCode: updatedData.erpProductCategoryCode,
    comment: updatedData.comment,
    delete: 0
  });
  return request.data;
}

export async function salesmanProductGroupSearchRequest(salesman) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5012',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,
  });
  return request.data;
}


//salesman Ürün grupları listesi
export async function salesmanProductSubCategoryListRequest(salesman) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5013',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,

  });
  return request.data;
}

export async function salesmanProductSubCategoryAddRequest(salesman,salesmanProductSubGroupRef,itemCategory) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5014',
    vendorId: appVendorID,
    token: appToken,
    salesmanProductSubCategoryRef: salesmanProductSubGroupRef,
    salesmanRef: salesman.salesManRef,
    productSubCategoryCode:itemCategory,
    comment: "",
    delete: 0
  });
  return request.data;
}

export async function salesmanProductSubCategoryUpdateRequest(salesman,updatedData) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5014',
    vendorId: appVendorID,
    token: appToken,
    salesmanProductSubCategoryRef: updatedData.salesmanProductSubGroupRef,
    salesmanRef: salesman.salesManRef,
    productSubCategoryCode: updatedData.erpProductSubCategoryCode,
    comment: updatedData.comment,
    delete: 0
  });
  return request.data;
}


export async function salesmanProductSubCategoryDeleteRequest(salesman,salesmanProductSubGroupRef,itemCategory) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5014',
    vendorId: appVendorID,
    token: appToken,
    salesmanProductSubCategoryRef: salesmanProductSubGroupRef,
    salesmanRef: salesman.salesManRef,
    productSubCategoryCode:itemCategory,
    comment: "",
    delete: 1
  });
  return request.data;
}


export async function salesmanProductSubCategorySearchRequest(salesman) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5015',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,
  });
  return request.data;
}

//salesman Ürün grupları listesi
export async function salesmanProductGroupsListRequest(salesman) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5010',
    vendorId: appVendorID,
    token: appToken,
    salesmanRef: salesman.salesManRef,

  });
  return request.data;
}

// General/Campaigns isteği

export async function generalCampaignsRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5060',
    vendorId: appVendorID,
    token: appToken,
    beginDate: "",
  });
  return request.data;
}

// General/Campaign post isteği

export async function generalCampaignPostRequest(campaign: CampaignModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5061',
    vendorId: appVendorID,
    token: appToken,
    campaignRef: campaign.campaignRef,
    campaignCode: campaign.campaignCode,
    campaignName: campaign.campaignName,
    campaignStatus: campaign.campaignStatus,
    forCertainCustomers: campaign.forCertainCustomers,
    isDiscPercent: campaign.isDiscPercent,
    amountDepended: campaign.amountDepended,
    customerSelectionType: campaign.customerSelectionType,
    campaignGroupRef: campaign.campaignGroupRef,
    runManually: campaign.runManually,
    erpCostCode: campaign.erpCostCode,
    erpClSpeCode1: campaign.erpClSpeCode1,
    erpClSpeCode2: campaign.erpClSpeCode2,
    beginDate: campaign.beginDate,
    endDate: campaign.endDate,
    comment: campaign.comment,

  });
  return request.data;
}

// General/Campaign DELETE isteği

export async function generalCampaignDeleteRequest(campaign: CampaignModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5061',
    vendorId: appVendorID,
    token: appToken,
    campaignRef: campaign.campaignRef,
    campaignCode: campaign.campaignCode,
    campaignName: campaign.campaignName,
    campaignStatus: 2,
    forCertainCustomers: campaign.forCertainCustomers,
    customerSelectionType: campaign.customerSelectionType,
    campaignGroupRef: campaign.campaignGroupRef,
    isDiscPercent: campaign.isDiscPercent,
    amountDepended: campaign.amountDepended,
    runManually: campaign.runManually,
    erpCostCode: campaign.erpCostCode,
    erpClSpeCode1: campaign.erpClSpeCode1,
    erpClSpeCode2: campaign.erpClSpeCode2,
    beginDate: campaign.beginDate,
    endDate: campaign.endDate,
    comment: campaign.comment,

  });
  return request.data;
}



// General/Campaign Product List isteği

export async function generalCampaignProductListRequest(campaignRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5062',
    vendorId: appVendorID,
    token: appToken,
    campaignRef: campaignRef,

  });
  return request.data;
}

// General/Campaign Customer List isteği

export async function generalCampaignCustomerListRequest(campaignRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5064',
    vendorId: appVendorID,
    token: appToken,
    campaignRef: campaignRef,

  });
  return request.data;
}

// General/Campaign Product Search isteği

export async function campaignProductSearchRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5066',
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}

// General/Campaign Product Post isteği

export async function campaignProductSelectRequest(campaignRef, erpItemRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5063',
    vendorId: appVendorID,
    token: appToken,
    campaignProductRef: 0,
    campaignRef: campaignRef,
    erpItemRef: erpItemRef,
    erpItemUnit: "PK",
    campaignPrice: 0,
    campaignSRP: 0,
    campaignPercent: 0,
    campaignItemAmount: 0,
    campaignMinAmount: 0,
    campaignMaxAmount: 0,
    campaignRunManually: 0,
    erpItemPrice: 0,
    erpItemSRP: 0,
    campaignGroup: "",
    showOnStart: 1,
    comment: "",
    productStatus: 1,
    imported: 0
  });
  return request.data;
}

// General/Campaign Product Edit isteği

export async function campaignProductUpdateRequest(product) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5063',
    vendorId: appVendorID,
    token: appToken,
    campaignProductRef: product.campaignProductRef,
    campaignRef: product.campaignRef,
    erpItemRef: product.erpItemRef,
    erpItemUnit: "PK",
    erpItemPrice: product.erpItemPrice,
    erpItemSRP: product.erpItemSRP,
    campaignPrice: product.campaignPrice,
    campaignSRP: product.campaignSRP,
    campaignPercent: product.campaignPercent,
    campaignItemAmount: product.campaignItemAmount,
    campaignMinAmount: product.campaignMinAmount,
    campaignMaxAmount: product.campaignMaxAmount,
    campaignRunManually: product.campaignRunManually,
    campaignGroup: product.campaignGroup,
    showOnStart: product.showOnStart,
    comment: product.comment,
    productStatus: 1,
    imported: product.imported

  });
  return request.data;
}

// General/Campaign Product Delete isteği

export async function campaignProductDeleteRequest(product) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5063',
    vendorId: appVendorID,
    token: appToken,
    campaignProductRef: product.campaignProductRef,
    campaignRef: product.campaignRef,
    erpItemRef: product.erpItemRef,
    erpItemUnit: "PK",
    campaignPrice: product.campaignPrice,
    campaignSRP: product.campaignSRP,
    campaignPercent: product.campaignPercent,
    campaignItemAmount: product.campaignItemAmount,
    campaignMinAmount: product.campaignMinAmount,
    campaignMaxAmount: product.campaignMaxAmount,
    campaignRunManually: product.campaignRunManually,
    erpItemPrice: product.erpItemPrice,
    erpItemSRP: product.erpItemSRP,
    campaignGroup: product.campaignGroup,
    showOnStart: product.showOnStart,
    comment: "",
    productStatus: 2,
    imported: product.imported
  });
  return request.data;
}



// General/Campaign Customer Search isteği

export async function campaignCustomerSearchRequest(campaignRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5067',
    vendorId: appVendorID,
    token: appToken,
    campaignRef: campaignRef
  });
  return request.data;
}

// General/Campaign Customer Select isteği

export async function campaignCustomerSelectRequest(campaignRef, customer) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5065',
    vendorId: appVendorID,
    token: appToken,

    campaignCustomerRef: 0,
    campaignRef: campaignRef,
    customerRef: customer.customerRef,
    erpCustomerRef: customer.erpCustomerRef,
    erpShippingAdrRef: customer.erpShippingAdrRef,
    newErpShippingAdrRef: customer.erpShippingAdrRef,
    comment: "",
    status: 1,
    imported: 0
  });
  return request.data;
}

// General/Campaign Customer DELETE isteği

export async function campaignCustomerDeleteRequest(campaignRef, customer) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5065',
    vendorId: appVendorID,
    token: appToken,

    campaignCustomerRef: customer.campaignCustomerRef,
    campaignRef: campaignRef,
    customerRef: customer.customerRef,
    erpCustomerRef: customer.erpCustomerRef,
    erpShippingAdrRef: customer.erpShippingAdrRef,
    newErpShippingAdrRef: customer.erpShippingAdrRef,
    comment: "",
    status: 2,
    imported: customer.imported
  });
  return request.data;
}

// General/Campaign Customer UPDATE isteği

export async function campaignCustomerUpdateRequest(campaignRef, customer, old, neww) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5065',
    vendorId: appVendorID,
    token: appToken,

    campaignCustomerRef: customer.campaignCustomerRef,
    campaignRef: campaignRef,
    customerRef: customer.customerRef,
    erpCustomerRef: customer.erpCustomerRef,
    erpShippingAdrRef: old,
    newErpShippingAdrRef: neww,
    comment: customer.comment,
    status: 1,
    imported: customer.imported
  });
  return request.data;
}

// General/Campaign IMPORT Product CSV isteği

export async function campaignProductsImportRequest(campaignRef, list) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5068',
    vendorId: appVendorID,
    token: appToken,
    campaignRef: campaignRef,
    campaignProducts: JSON.stringify({ campaignProducts: list })
  });
  return request.data;
}

// General/Campaign IMPORT Customer CSV isteği

export async function campaignCustomersImportRequest(campaignRef, list) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5069',
    vendorId: appVendorID,
    token: appToken,
    campaignRef: campaignRef,
    campaignCustomers: JSON.stringify({ campaignCustomers: list })
  });
  return request.data;
}

// General/Campaign Customer Shipping Address List isteği

export async function campaignCustomerShippingAdressListRequest(erpCustomerRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5070',
    vendorId: appVendorID,
    token: appToken,
    erpCustomerRef: erpCustomerRef,
  });
  return request.data;
}


//Product Images List

export async function generalProductImagesListRequest(itemStatus) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5080',
    vendorId: appVendorID,
    token: appToken,
    itemStatus: itemStatus

  });
  return request.data;
}


//Segmentation List Request

export async function generalSegmentationListRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5090',
    vendorId: appVendorID,
    token: appToken,

  });
  return request.data;
}

//Segmentation Post Request

export async function generalSegmentationPostRequest(segment: SegmentModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5091',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segment.segmentRef,
    segmentType: segment.segmentType,
    segmentStatus: segment.segmentStatus,
    segmentCode: segment.segmentCode,
    segmentName: segment.segmentName,
    speCode1: segment.speCode1,
    speCode2: segment.speCode2,
    productSelectionType: segment.productSelectionType,
    customerSelectionType: segment.customerSelectionType,
    brandSelectionType: segment.brandSelectionType,
    productGroupSelectionType: segment.productGroupSelectionType,
    comment: segment.comment


  });
  return request.data;
}

//Segmentation DELETE Request

export async function generalSegmentationDeleteRequest(segment: SegmentModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5091',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segment.segmentRef,
    segmentType: segment.segmentType,
    segmentStatus: 2,
    segmentCode: segment.segmentCode,
    segmentName: segment.segmentName,
    speCode1: segment.speCode1,
    speCode2: segment.speCode2,
    productSelectionType: segment.productSelectionType,
    customerSelectionType: segment.customerSelectionType,
    brandSelectionType: segment.brandSelectionType,
    productGroupSelectionType: segment.productGroupSelectionType,
    comment: segment.comment

  });
  return request.data;
}


//Segmentation Product List Request

export async function generalSegmentationProductListRequest(segmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5110',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef,
    segmentProductType: 0

  });
  return request.data;
}

//Segmentation Customer List Request

export async function generalSegmentationCustomerListRequest(segmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5094',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef
  });
  return request.data;
}


//Segmentation Product UPDATE Request

export async function generalSegmentationProductUpdateRequest(segmentProduct: SegmentProductModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5111',
    vendorId: appVendorID,
    token: appToken,
    segmentProductRef: segmentProduct.segmentProductRef,
    segmentProductType: segmentProduct.segmentProductType,
    segmentRef: segmentProduct.segmentRef,
    erpItemRef: segmentProduct.erpItemRef,
    customerRef: 0,
    erpCustomerRef: 0,
    erpShippingAdrRef: 0,
    comment: segmentProduct.comment,
    visibility: 1,
    delete: 0
  });
  return request.data;
}


//Segmentation Product DELETE Request

export async function generalSegmentationProductDeleteRequest(segmentProduct: SegmentProductModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5111',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentProduct.segmentRef,
    segmentProductType: 0,
    segmentProductRef: segmentProduct.segmentProductRef,
    customerRef: 0,
    erpCustomerRef: 0,
    erpShippingAdrRef: 0,
    erpItemRef: 0,
    visibility: 1,
    comment: "",
    delete: 1

  });
  return request.data;
}


//Segmentation Product INSERT Request

export async function generalSegmentationProductInsertRequest(segmentRef, erpItemRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5111',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef,
    segmentProductType: 0,
    segmentProductRef: 0,
    customerRef: 0,
    erpCustomerRef: 0,
    erpShippingAdrRef: 0,
    erpItemRef: erpItemRef,
    visibility: 1,
    comment: "",
    delete: 0

  });
  return request.data;

}


//Segmentation Customer INSERT Request

export async function generalSegmentationCustomerInsertRequest(segmentRef, customer) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5095',
    vendorId: appVendorID,
    token: appToken,
    segmentCustomerRef: 0,
    segmentCustomerType: 0,
    segmentRef: segmentRef,
    customerRef: 0,
    erpCustomerRef: customer.erpCustomerRef,
    erpShippingAdrRef: customer.erpShippingAdrRef,
    comment: "",
    delete: 0
  });
  return request.data;
}



//Segmentation Customer UPDATE Request

export async function generalSegmentationCustomerUpdateRequest(segmentCustomer: SegmentCustomerModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5095',
    vendorId: appVendorID,
    token: appToken,
    segmentCustomerRef: segmentCustomer.segmentCustomerRef,
    segmentCustomerType: segmentCustomer.segmentCustomerType,
    segmentRef: segmentCustomer.segmentRef,
    customerRef: segmentCustomer.customerRef,
    erpCustomerRef: segmentCustomer.erpCustomerRef,
    erpShippingAdrRef: segmentCustomer.erpShippingAdrRef,
    comment: segmentCustomer.comment,
    delete: 0
  });
  return request.data;
}

//Segmentation Customer DELETE Request

export async function generalSegmentationCustomerDeleteRequest(segmentCustomer: SegmentCustomerModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5095',
    vendorId: appVendorID,
    token: appToken,
    segmentCustomerRef: segmentCustomer.segmentCustomerRef,
    segmentCustomerType: segmentCustomer.segmentCustomerType,
    segmentRef: segmentCustomer.segmentRef,
    customerRef: segmentCustomer.customerRef,
    erpCustomerRef: segmentCustomer.erpCustomerRef,
    erpShippingAdrRef: segmentCustomer.erpShippingAdrRef,
    comment: segmentCustomer.comment,
    delete: 1
  });
  return request.data;
}

//Segmentation ProductGroups List Request

export async function generalSegmentationProductGroupsListRequest(segmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5096',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef,
    segmentProductGroupType: 0
  });
  return request.data;
}


//Segmentation ProductGroups UPDATE Request

export async function generalSegmentationProductGroupsUpdateRequest(segmenProductGroup: SegmentProductGroupModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5097',
    vendorId: appVendorID,
    token: appToken,
    segmentProductGroupRef: segmenProductGroup.segmentProductGroupRef,
    segmentProductGroupType: 0,
    segmentRef: segmenProductGroup.segmentRef,
    productGroupCode: segmenProductGroup.productGroupCode,
    comment: segmenProductGroup.comment,
    delete: 0
  });
  return request.data;
}

//Segmentation ProductGroups INSERT Request

export async function generalSegmentationProductGroupsInsertRequest(segmentRef, segmentProductGroup: SegmentProductGroupModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5097',
    vendorId: appVendorID,
    token: appToken,
    segmentProductGroupRef: 0,
    segmentProductGroupType: 0,
    segmentRef: segmentRef,
    productGroupCode: segmentProductGroup["itemCategory"],
    comment: "",
    delete: 0
  });
  return request.data;
}

//Segmentation ProductGroups DELETE Request

export async function generalSegmentationProductGroupsDeleteRequest(segmenProductGroup: SegmentProductGroupModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5097',
    vendorId: appVendorID,
    token: appToken,
    segmentProductGroupRef: segmenProductGroup.segmentProductGroupRef,
    segmentProductGroupType: 0,
    segmentRef: segmenProductGroup.segmentRef,
    productGroupCode: segmenProductGroup.productGroupCode,
    comment: segmenProductGroup.comment,
    delete: 1
  });
  return request.data;
}



//Segmentation Customer Search List Request

export async function segmentCustomerSearchListRequest(segmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5099',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef
  });
  return request.data;
}

//Segmentation Product Group Search List Request

export async function segmentProductGroupSearchListRequest(segmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5100',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef,
    segmentProductGroupType: 0
  });
  return request.data;
}

//Segmentation Brands Search List Request

export async function segmentBrandsSearchListRequest(segmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5100',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef,
    segmentProductGroupType: 1
  });
  return request.data;
}

//Segmentation Brands List Request

export async function generalSegmentationBrandsListRequest(segmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5096',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef,
    segmentProductGroupType: 1
  });
  return request.data;
}


//Segmentation Brands UPDATE Request

export async function generalSegmentationBrandsUpdateRequest(segmenProductGroup: SegmentProductGroupModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5097',
    vendorId: appVendorID,
    token: appToken,
    segmentProductGroupRef: segmenProductGroup.segmentProductGroupRef,
    segmentProductGroupType: 1,
    segmentRef: segmenProductGroup.segmentRef,
    productGroupCode: segmenProductGroup.productGroupCode,
    comment: segmenProductGroup.comment,
    delete: 0
  });
  return request.data;
}

//Segmentation Brands INSERT Request

export async function generalSegmentationBrandsInsertRequest(segmentRef, segmentProductGroup: SegmentProductGroupModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5097',
    vendorId: appVendorID,
    token: appToken,
    segmentProductGroupRef: 0,
    segmentProductGroupType: 1,
    segmentRef: segmentRef,
    productGroupCode: segmentProductGroup["itemSubCategory"],
    comment: "",
    delete: 0
  });
  return request.data;
}


//Segmentation Brands DELETE Request

export async function generalSegmentationBrandsDeleteRequest(segmenProductGroup: SegmentProductGroupModel) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5097',
    vendorId: appVendorID,
    token: appToken,
    segmentProductGroupRef: segmenProductGroup.segmentProductGroupRef,
    segmentProductGroupType: 1,
    segmentRef: segmenProductGroup.segmentRef,
    productGroupCode: segmenProductGroup.productGroupCode,
    comment: segmenProductGroup.comment,
    delete: 1
  });
  return request.data;
}

//Incentives List Request

export async function generalIncentivesListRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5110',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: 0,
    segmentProductType: 1
  });
  return request.data;
}


//Incentives INSERT Request

export async function generalIncentivesInsertRequest(erpItemRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5111',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: 0,
    segmentProductType: 1,
    segmentProductRef: 0,
    customerRef: 0,
    erpCustomerRef: 0,
    erpShippingAdrRef: 0,
    erpItemRef: erpItemRef,
    visibility: 1,
    comment: "",
    delete: 0

  });
  return request.data;
}


//Incentives DELETE Request

export async function generalIncentivesDeleteRequest(segmentProductRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5111',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: 0,
    segmentProductType: 1,
    segmentProductRef: segmentProductRef,
    customerRef: 0,
    erpCustomerRef: 0,
    erpShippingAdrRef: 0,
    erpItemRef: 0,
    visibility: 1,
    comment: "",
    delete: 1

  });
  return request.data;
}

//New Products List Request

export async function generalNewProductsListRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5110',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: 0,
    segmentProductType: 3
  });
  return request.data;
}


//New Products INSERT Request

export async function generalNewProductsInsertRequest(erpItemRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5111',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: 0,
    segmentProductType: 3,
    segmentProductRef: 0,
    customerRef: 0,
    erpCustomerRef: 0,
    erpShippingAdrRef: 0,
    erpItemRef: erpItemRef,
    visibility: 1,
    comment: "",
    delete: 0

  });
  return request.data;
}


//New Products DELETE Request

export async function generalNewProductsDeleteRequest(segmentProductRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5111',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: 0,
    segmentProductType: 3,
    segmentProductRef: segmentProductRef,
    customerRef: 0,
    erpCustomerRef: 0,
    erpShippingAdrRef: 0,
    erpItemRef: 0,
    visibility: 1,
    comment: "",
    delete: 1

  });
  return request.data;
}


//New Products List Request

export async function generalProductSearch(segmentRef, segmentProductType) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5112',
    vendorId: appVendorID,
    token: appToken,
    segmentRef: segmentRef,
    segmentProductType: segmentProductType
  });
  return request.data;
}


//Finance List Sell Request

export async function paymentsListSellRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5300',
    vendorId: appVendorID,
    token: appToken,
    cardtype: 1,
  });
  return request.data;
}

//Finance List Buy Request

export async function paymentsListBuyRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5300',
    vendorId: appVendorID,
    token: appToken,
    cardtype: 2,
  });
  return request.data;
}

//CampaignGroupsList

export async function campaignGroupsListRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5071',
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}

//CampaignGroups INSERT

export async function campaignGroupInsertRequest(group) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5072',
    vendorId: appVendorID,
    token: appToken,
    groupRef: group.groupRef,
    groupStatus: group.groupStatus,
    groupCode: group.groupCode,
    groupName: group.groupName,
    comment: group.comment
  });
  return request.data;
}

//CampaignGroups DELETE

export async function campaignGroupDeleteRequest(group) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5072',
    vendorId: appVendorID,
    token: appToken,
    groupRef: group.groupRef,
    groupStatus: 3,
    groupCode: group.groupCode,
    groupName: group.groupName,
    comment: group.comment
  });
  return request.data;
}


//UserGroupsList

export async function userGroupsListRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5073',
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}

//UserGroups INSERT

export async function userGroupInsertRequest(group) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5074',
    vendorId: appVendorID,
    token: appToken,
    groupRef: group.groupRef,
    groupStatus: group.groupStatus,
    groupCode: group.groupCode,
    groupName: group.groupName,
    comment: group.comment
  });
  return request.data;
}

//UserGroups DELETE

export async function userGroupDeleteRequest(group) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5074',
    vendorId: appVendorID,
    token: appToken,
    groupRef: group.groupRef,
    groupStatus: 3,
    groupCode: group.groupCode,
    groupName: group.groupName,
    comment: group.comment
  });
  return request.data;
}




//Registrants Get List

export async function registrantsListRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '1118',
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}

export async function registrantDetailstRequest(requestRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5350',
    vendorId: appVendorID,
    token: appToken,
    requestRef: requestRef
  });
  return request.data;
}

//Registrants Update Record

export async function registrantsUpdateRecordRequest(record) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '1119',
    vendorId: appVendorID,
    token: appToken,

    requestRef: record["requestRef"],
    requestStatus: record["requestStatus"],
    requestNote: record["requestNote"] ?? "",

    "shopUserFirstname": record["shopUserFirstname"],
    "shopUserSurname": record["shopUserSurname"],
    "shopUserEmail": record["shopUserEmail"],
    "shopUserPhone": record["shopUserPhone"],

    "customerName": record["customerName"],
    "customerVATNr": record["customerVATNr"] ?? "",
    "customerTaxNr": record["customerTaxNr"] ?? "",
    "customerAddress": record["customerAddress"],
    "customerPostCode": record["customerPostCode"],
    "customerCity": record["customerCity"],
    "customerCountry": record["customerCountry"],
    "customerCountryCode": record["customerCountryCode"],
    "customerAdrInfo": record["customerAdrInfo"],

    "shippingAddress": record["shippingAddress"] ?? "",
    "shippingPostCode": record["shippingPostCode"] ?? "",
    "shippingCity": record["shippingCity"] ?? "",
    "shippingCountry": record["shippingCountry"] ?? "",
    "shippingCountryCode": record["shippingCountryCode"] ?? "",
    "shippingAdrInfo": record["shippingAdrInfo"] ?? "",
    "shippingAdrName": record["shippingAdrName"] ?? "",

    "tradingGroup": record["tradingGroup"] ?? "",
    "payPlanCode": record["payPlanCode"] ?? "",
    "priceList": record["priceList"] ?? "",

    "docType1": record["docType1"] ?? "",
    "docType2": record["docType2"] ?? "",
    "docType3": record["docType3"] ?? "",

    "customerCode": record["customerCode"] ?? "",
    "erpCustomerCode": record["erpCustomerCode"] ?? "",
    "erpShippingAdrCode": record["erpShippingAdrCode"] ?? "",
    "companyDesc": record["companyDesc"] ?? "",
    comment: "",
    customerGroupRef: record["customerGroupRef"],
    segmentRef: record["segmentRef"]

  });
  return request.data;
}


export async function registerConfirmation(requestRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '4010',
    vendorId: appVendorID,
    token: appToken,
    requestRef: requestRef,
  });
  return request.data;
}


// e-invoice

export async function IncomingInvoicesRequest(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5201',
    vendorId: appVendorID,
    token: appToken,
    invoiceStatus: 0,
    moduleNr: 2,
    begindate: beginDate,
    enddate: endDate
  });
  return request.data;
}

export async function OutgoingInvoicesRequest(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5201',
    vendorId: appVendorID,
    token: appToken,
    invoiceStatus: 0,
    moduleNr: 1,
    begindate: beginDate,
    enddate: endDate,
  });
  return request.data;
}

export async function customerParametersRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5203',
    vendorId: appVendorID,
    token: appToken,
    cardType: 1
  });
  return request.data;
}

export async function supplierParametersRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5203',
    vendorId: appVendorID,
    token: appToken,
    cardType: 2
  });
  return request.data;
}

export async function supplierFindMatchRequest(supplierName, supplierAdr, supplierCity, supplierVatId, supplierIban) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5214',
    vendorId: appVendorID,
    token: appToken,
    supplierName: supplierName ?? "",
    supplierAdr: supplierAdr ?? "",
    supplierCity: supplierCity ?? "",
    supplierVatId: supplierVatId ?? "",
    supplierIban: supplierIban ?? ""
  });
  return request.data;
}

export async function parameterRequest(parameter, type) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5204',
    vendorId: appVendorID,
    token: appToken,
    cardType: type,
    erpArpRef: parameter.erpArpRef,
    registrationName: parameter.registrationName,
    arpStatus: parameter.arpStatus,
    arpStreet: parameter.arpStreet,
    arpCity: parameter.arpCity,
    arpPostCode: parameter.arpPostCode,
    arpCountryCode: parameter.arpCountryCode,
    arpCountry: parameter.arpCountry,
    arpVatId: parameter.arpVatId,
    arpTaxNr: parameter.arpTaxNr,
    tradingGroup: parameter.tradingGroup,
    arpEMail: parameter.arpEMail,
    contactName: parameter.contactName,
    contactPhone: parameter.contactPhone,
    contactEMail: parameter.contactEMail,

    registerNumber: parameter.registerNumber ?? "",
    legalForm: parameter.legalForm ?? "",
    arpIban: parameter.arpIban ?? "",
    leitwegId: parameter.leitwegId ?? "",
    endpointId: parameter.endpointId ?? "",
    gln: parameter.gln ?? ""


  });
  return request.data;
}


export async function invoiceStatusChangeRequest(ref, status) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5207',
    vendorId: appVendorID,
    token: appToken,
    eInvoiceStatus: status,
    erpInvoiceRef: ref,

  });
  return request.data;
}

export async function invoiceSendToApiRequest(erpSupplierRef, eInvoiceType, invoiceIssueDate, invoiceDueDate, invoiceNr, invoiceTotal, attachmentRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5208',
    vendorId: appVendorID,
    token: appToken,
    erpSupplierRef: erpSupplierRef,
    eInvoiceType: eInvoiceType,
    invoiceIssueDate: invoiceIssueDate,
    invoiceDueDate: invoiceDueDate,
    invoiceNr: invoiceNr,
    invoiceTotal: invoiceTotal,
    attachmentRef: attachmentRef

  });
  return request.data;
}



export async function incomeInvoiceLookupCustomerRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5209',
    vendorId: appVendorID,
    token: appToken,

  });
  return request.data;
}

export async function einvoiceChangeSupplierRequest(eInvoiceRef, erpSupplierRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5213',
    vendorId: appVendorID,
    token: appToken,
    eInvoiceRef: eInvoiceRef,
    erpSupplierRef: erpSupplierRef

  });
  return request.data;
}


export async function getEInvoiceKeyRequest(eInvoiceRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5210',
    vendorId: appVendorID,
    token: appToken,
    eInvoiceRef: eInvoiceRef

  });
  return request.data;
}


export const getInvoice = async (invoiceRef) => {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  try {

    const response = await fetch('https://api.fbsshop.de', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        serviceId: "5202",
        vendorId: appVendorID,
        token: appToken,
        erpInvoiceRef: invoiceRef
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP hata! durum: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};



export const getPDF = async (invoiceRef) => {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  try {

    const response = await fetch('https://api.fbsshop.de', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        serviceId: "5203", // PDF servisi için
        vendorId: appVendorID,
        token: appToken,
        invoiceRef: invoiceRef
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP hata! durum: ${response.status}`);
    }

    const data = await response.json(); // PDF URL'sini al
    return data.pdfUrl; // PDF URL'sini döndür
  } catch (error) {
    console.error('PDF alınırken hata:', error);
    throw error;
  }
};


//node sunucu: xml dosyasını mobioffice/einvoices klasörüne yükler

export async function xmlToServer(invoiceID, xmlContent, eInvoiceKey) {
  var appVendorID = getVendorId();
  var request = await axios.post("https://services.mobiapi.de/upload",
    {
      vendorID: appVendorID,
      invoiceID: invoiceID,
      xml: xmlContent,
      eInvoiceKey: eInvoiceKey
    });
  return request.data;
}

//node sunucu xml-to-json

export async function xmlToJsonRequest(xmlContent) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://services.mobiapi.de/xml-to-json",
    {
      xml: xmlContent,
      vendorID: appVendorID,
      token: appToken
    });
  return request.data;
}

//node sunucu json-to-xml

export async function jsonToXmlRequest(jsonContent) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://services.mobiapi.de/json-to-xml",
    {
      json: jsonContent,
      vendorID: appVendorID,
      token: appToken
    });
  return request.data;
}


//Base 64 Preview

export async function base64Preview(moduleNr, recordNr) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '3002',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: moduleNr,
    recordNr: recordNr,
  });
  return request.data;
}


//Base 64 Upload

export async function base64Upload(fileFolder, fileName, fileBase64) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '3003',
    vendorId: appVendorID,
    token: appToken,
    fileName: fileName,
    fileFolder: fileFolder,
    fileBase64: fileBase64
  });
  return request.data;

}


//Base 64 Download

export async function base64Download(fileFolder, fileName) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '3004',
    vendorId: appVendorID,
    token: appToken,
    fileName: fileName,
    fileFolder: fileFolder,
  });
  return request.data;
}

// TRANSACTION

export async function financeTransactionRequest() {

  var request = await axios.get("https://stripe.mobiapi.de/payments");
  return request.data;
}


//SETTINGS

//get setting
export async function getSettingJSONRequest(settingModuleNr, settingCode) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5250',
    vendorId: appVendorID,
    token: appToken,
    settingModuleNr: settingModuleNr,
    settingCode: settingCode,
  });
  return request.data;
}

//set setting
export async function sendSettingJSONRequest(settingModuleNr, settingCode, settingJson) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5251',
    vendorId: appVendorID,
    token: appToken,
    settingModuleNr: settingModuleNr,
    settingCode: settingCode,
    settingJson: settingJson,
  });
  return request.data;
}


//ftp test

export async function ftpTESTRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://image.mobiapi.de/ftp-test", {
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}


//smtp test

export async function smtpOutgoingTESTRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/smtp-outgoing-test", {
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}

//smtp test mail Accounts

export async function mailAccountSmtpOutgoingTESTRequest(mailAccountRef) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/smtp-outgoing-test", {
    vendorId: appVendorID,
    token: appToken,
    mailAccountRef: mailAccountRef
  });
  return request.data;
}


//smtp test incoming

export async function imapIncomingTESTRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/imap-incoming-test", {
    vendorId: appVendorID,
    token: appToken,
  });
  return request.data;
}

//smtp test incoming

export async function mailAccountImapIncomingTESTRequest(mailAccountRef) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/imap-incoming-test", {
    vendorId: appVendorID,
    token: appToken,
    mailAccountRef: mailAccountRef
  });
  return request.data;
}


//mail inbox
export async function einvoiceMailInboxRequest(startDate, endDate) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/mail-inbox", {
    vendorId: appVendorID,
    token: appToken,
    startDate: startDate,
    endDate: endDate
  });
  return request.data;
}


//mail detail
export async function einvoiceMailDetailRequest(messageId) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/mail-details", {
    vendorId: appVendorID,
    token: appToken,
    messageId: messageId,
  });
  return request.data;
}

//mail get file
export async function einvoiceMailGetFileRequest(messageId, checksum) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/get-file", {
    vendorId: appVendorID,
    token: appToken,
    checksum: checksum,
    messageId: messageId
  });
  return request.data;
}

//mail change isRead status
export async function einvoiceMailChangeStatusRequest(messageId, status) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post("https://mail.mobiapi.de/change-isread-status", {
    vendorId: appVendorID,
    token: appToken,
    messageId: messageId,
    status: status
  });
  return request.data;
}


//mailbox isRead from api

export async function einvoiceMailIsReadFromApiRequest(beginDate, endDate, mailAccountRef) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5221',
    vendorId: appVendorID,
    token: appToken,
    beginDate: beginDate,
    endDate: endDate,
    mailAccountRef: mailAccountRef ?? 0,
    moduleNr: 1
  });
  return request.data;
}

//mailbox isRead set mail

export async function einvoiceMailIsReadSetMailRequest(status, mailId, sender, date, mailAccountRef) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5222',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: 1,
    mailStatus: status,
    mailId: mailId,
    mailSender: sender,
    mailDate: date,
    mailAccountRef: mailAccountRef
  });
  return request.data;
}

//mailbox isRead set file

export async function einvoiceMailIsReadSetFileRequest(status, fileId, description, mailRef, validationUrl, comment) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5223',
    vendorId: appVendorID,
    token: appToken,
    attachmentStatus: status,
    attachmentId: fileId,
    attachmentName: description ?? "",
    attachmentType: 1,
    mailRef: mailRef,
    validationUrl: validationUrl ?? "",
    comment: comment ?? ""
  });
  return request.data;
}

//mail Accounts

export async function getMailAccountsRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5224',
    vendorId: appVendorID,
    token: appToken,

  });
  return request.data;
}

export async function settMailAccountRequest(mailAccountRef, mailAccountName, mailAccountStatus, smtp_Settings, imap_Settings, comment) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5225',
    vendorId: appVendorID,
    token: appToken,
    mailAccountRef,
    mailAccountName,
    mailAccountStatus,
    smtp_Settings,
    imap_Settings,
    comment: comment ?? ""

  });
  return request.data;
}


export async function sendNewSettingPayload(payload) {
  const appToken = getAppToken();
  const appVendorID = getVendorId();
  const request = await axios.post(apiUrl, {
    serviceId: "5261",
    vendorId: appVendorID,
    token: appToken,
    ...payload,
    settingModuleNr: 1000,
  });
  return request.data;
}


export async function deleteSettingRequest(settingRef) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5264',
    vendorId: appVendorID,
    token: appToken,
    settingRef: settingRef,
  });
  return request.data;
}

// edi listeleme - 5211
// desadv outgoing
export async function DesadvList(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5211',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: 2,
    beginDate: beginDate,
    endDate: endDate,
    direction: 2,
  });
  return request.data;
}

// orders outgoing
export async function OrdersList(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5211',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: 3,
    beginDate: beginDate,
    endDate: endDate,
    direction: 2,
  });
  return request.data;
}

// invoic outgoing
export async function InvoicList(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5211',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: 4,
    beginDate: beginDate,
    endDate: endDate,
    direction: 2,
  });
  return request.data;
}

// desadv incoming
export async function DesadvIncoming(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5211',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: 2,
    beginDate: beginDate,
    endDate: endDate,
    direction: 1,
  });
  return request.data;
}

// orders incoming
export async function OrdersIncoming(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5211',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: 3,
    beginDate: beginDate,
    endDate: endDate,
    direction: 1,
  });
  return request.data;
}

// invoic incoming
export async function InvoicIncoming(beginDate, endDate) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5211',
    vendorId: appVendorID,
    token: appToken,
    moduleNr: 4,
    beginDate: beginDate,
    endDate: endDate,
    direction: 1,
  });
  return request.data;
}

// edi bilgi alma - 5212
// desadv bilgiler
export const getDesadv = async (erpSlipRef) => {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  try {

    const response = await fetch('https://api.fbsshop.de', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        serviceId: "5212",
        vendorId: appVendorID,
        token: appToken,
        erpSlipRef: erpSlipRef,
        moduleNr: 2
      })
    });
    if (!response.ok) {
      throw new Error(`HTTP hata! durum: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

//orders bilgiler
export const getOrders = async (erpSlipRef) => {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  try {

    const response = await fetch('https://api.fbsshop.de', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        serviceId: "5212",
        vendorId: appVendorID,
        token: appToken,
        erpSlipRef: erpSlipRef,
        moduleNr: 3
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP hata! durum: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

//invoic bilgiler
export const getInvoicEdi = async (erpSlipRef) => {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  try {

    const response = await fetch('https://api.fbsshop.de', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        serviceId: "5212",
        vendorId: appVendorID,
        token: appToken,
        erpSlipRef: erpSlipRef,
        moduleNr: 4
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP hata! durum: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

//5209 benzeri müşteri çekme
export async function incomeOrdersLookupRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5216',
    vendorId: appVendorID,
    token: appToken,
    cardType: 1

  });
  return request.data;
}

//5214 benzeri - müşteri eşleştirme
export async function EdicustomerFindMatchRequest(arpName, arpAdr, arpCity, arpVatId, arpIban, cardType) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5217',
    vendorId: appVendorID,
    token: appToken,
    arpName: arpName ?? "",
    arpAdr: arpAdr ?? "",
    arpCity: arpCity ?? "",
    arpVatId: arpVatId ?? "",
    arpIban: arpIban ?? "",
    cardType: cardType
  });
  return request.data;
}



export async function setDefaultSettingRequest(settingRef) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5263',
    vendorId: appVendorID,
    token: appToken,
    settingRef: settingRef,
  });
  return request.data;
}
export async function deleteThemeRequest(settingRef: number) {
  const appToken = getAppToken();
  const appVendorID = getVendorId();
  const response = await axios.post(apiUrl, {
    serviceId: '5264',
    vendorId: appVendorID,
    token: appToken,
    settingRef: settingRef,
  });
  return response.data;
}

export async function pageSettingsPostRequest(params: ISettingRequestParams) {
  const appToken = getAppToken();
  const appVendorID = getVendorId();

  try {
    const { settingRef, settingPage, settingObject, settingName, settingJson } = params;
    const { data } = await axios.post(apiUrl, {
      serviceId: "5261",
      vendorId: appVendorID,
      token: appToken,
      settingRef,
      settingType: 1,
      isDefault: 0,
      settingStatus: 1,
      settingModuleNr: 1010,
      settingPage,
      settingObject,
      settingName,
      settingJson,
      comment: "",
    });
    return data;
  } catch (error) {
    console.error("Error in pageSettingsPostRequest:", error);
    throw error;
  }
}



export async function getSettingListRequest(settingStatus) {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5260',
    vendorId: appVendorID,
    token: appToken,
    settingModuleNr: 1000,
    settingType: 2,
    settingStatus: settingStatus,
    isDefault: 0,
    settingPage: "theme",
    settingObject: "dx-datagrid-theme",
  });
  return request.data;
}
export async function getSettingDefaultListRequest() {
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5262',
    vendorId: appVendorID,
    token: appToken,
    settingModuleNr: 1000,
    settingType: 2,
    settingPage: "theme",
    settingObject: "dx-datagrid-theme",
  });
  return request.data;
}

export async function pageSettingsGetListRequest(settingPage, settingObject) {
  const appVendorID = getVendorId();
  const appToken = getAppToken();
  const request = await axios.post(apiUrl, {
    serviceId: "5260",
    vendorId: appVendorID,
    token: appToken,
    settingRef: 0,
    settingType: 1,
    settingStatus: 1,
    isDefault: 0,
    settingModuleNr: 1010,
    settingPage: settingPage,
    settingObject: settingObject,
  });
  return request.data;
}
export async function pageSettingsGetDefaultListRequest(settingPage, settingObject) {
  const appVendorID = getVendorId();
  const appToken = getAppToken();
  const request = await axios.post(apiUrl, {
    serviceId: "5262",
    vendorId: appVendorID,
    token: appToken,
    settingRef: 0,
    settingType: 1,
    isDefault: 1,
    settingStatus: 1,
    settingModuleNr: 1010,
    settingPage: settingPage,
    settingObject: settingObject,
  });
  return request.data;
}

export async function OrdersSendToApiRequest(erpArpRef, ediSlipType, slipDate, slipDueDate, slipNr, slipTotal) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5215',
    vendorId: appVendorID,
    token: appToken,
    "erpArpRef": erpArpRef,//1173
    "ediSlipType": ediSlipType,
    "ediSlipDate": slipDate,
    "ediSlipDueDate": slipDueDate,
    "ediSlipNr": slipNr,
    "ediSlipTotal": slipTotal,
    attachmentRef: "0",
    moduleNr: 3,
    erpShipInfoRef: 0,
    erpDeliveryPartyRef: 0,
    ediSlipData: 0,
    comment: "",


  });
  return request.data;
}

export async function getEdiKeyRequest(ediSlipRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5218',
    vendorId: appVendorID,
    token: appToken,
    ediSlipRef: ediSlipRef

  });
  return request.data;
}

//node sunucu: edifact dosyasını mobioffice/edi klasörüne yükler

export async function ediToServer(edicontent, ediKey) {
  var appVendorID = getVendorId();
  var request = await axios.post("https://edi.mobiapi.de/editext-to-server",
    {
      vendorID: appVendorID,
      type: "inbox",
      file: edicontent,
      ediKey: ediKey
    });
  return request.data;
}

export async function ediChangeSupplierRequest(ediSlipRef, erpArpRef) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5219',
    vendorId: appVendorID,
    token: appToken,
    ediSlipRef: ediSlipRef,
    ediArpRef: erpArpRef

  });
  return request.data;
}

//Export DATEV

export async function datevNewExportRequest(
  beginDate,
  endDate,
  datev
) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5021',
    vendorId: appVendorID,
    token: appToken,


    "beginDate": beginDate,
    "endDate": endDate,
    "datevSlipRef": datev.datevSlipRef,
    "datevSlipStatus": datev.datevSlipStatus,
    "taxAccountantNumber": datev.taxAccountantNumber,
    "taxAccountantClientNumber": datev.taxAccountantClientNumber,
    "startOfFinancialYear": datev.startOfFinancialYear,
    "chartOfAccountsRef": datev.chartOfAccountsRef,
    "documentImages": datev.documentImages,
    "documentFormat": datev.documentFormat,
    exportSD: datev.exportSD,
    exportPR: datev.exportPR,
    exportCash: datev.exportCash,
    exportBank: datev.exportBank,
    datevSlipKey: datev.datevSlipKey,
    datevSlipName: datev.datevSlipName,
    dictationAbbreviation: datev.dictationAbbreviation,
    "comment": datev.comment ?? ""



  });
  return request.data;
}



export async function datevListRequest(beginDate, endDate, datevSlipStatus) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5020',
    vendorId: appVendorID,
    token: appToken,
    beginDate: beginDate,
    endDate: endDate,
    datevSlipStatus: datevSlipStatus

  });
  return request.data;
}

export async function datevDocsListRequest(datev) {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5022',
    vendorId: appVendorID,
    token: appToken,
    datevSlipRef: datev?.datevSlipRef,
    "exportSD": datev.exportSD,
    "exportPR": datev.exportPR,
    "exportCash": datev.exportCash,
    "exportBank": datev.exportBank
  });
  return request.data;
}

export async function datevParamsGetRequest() {

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await axios.post(apiUrl, {
    serviceId: '5023',
    vendorId: appVendorID,
    token: appToken,

  });
  return request.data;
}

export async function datevParamsPostRequest(datevParams){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5024',
        vendorId: appVendorID,
        token: appToken,


        datevParamsRef: datevParams.datevParamsRef,
        chartOfAccountsRef: datevParams.chartOfAccountsRef,
        companyNumber: datevParams.companyNumber,
        datevFormatIndicator: datevParams.datevFormatIndicator,
        datevFormatVersion: datevParams.datevFormatVersion,
        dataCategory: datevParams.dataCategory,
        formatName: datevParams.formatName,
        formatVersion: datevParams.formatVersion,
        indicatorOfOrigin: datevParams.indicatorOfOrigin,
        datevLoginName: datevParams.datevLoginName,
        taxAccountantNumber: datevParams.taxAccountantNumber,
        taxAccountantClientNumber: datevParams.taxAccountantClientNumber,
        startOfFinancialYear: datevParams.startOfFinancialYear,
        accountLength: datevParams.generalLedgerAccountLength,
        bookingBatchName: datevParams.bookingBatchName,
        dictationAbbreviation: datevParams.dictationAbbreviation,
        bookingType: datevParams.bookingType,
        accountingPurpose: datevParams.accountingPurpose,
        fixedWriting: datevParams.fixedWriting,
        currency: datevParams.currency,
        comment: ""


      });
      return request.data;
}

export async function datevSlipFromServerRequest(datev){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post("https://edi.mobiapi.de/datev-export", {
        vendorId: appVendorID,
        token: appToken,
        datevSlipRef: datev?.datevSlipRef,
        "exportSD": datev.exportSD,
        "exportPR": datev.exportPR,
        "exportCash": datev.exportCash,
        "exportBank": datev.exportBank,
        "datevKey": datev.datevSlipKey


      },
      {
        responseType: "json" // Cevabı blob olarak al
    });
      return request.data;
}

export async function datevDownloadServerRequests(datev){
  var appVendorID = getVendorId();
  var response = await  axios.post("https://edi.mobiapi.de/datev-download",{
    vendorId: appVendorID,
    "datevKey": datev.datevSlipKey
  },
  {
    responseType: "blob" // Cevabı blob olarak al
});
  return response;
}
//bank
export async function getBankListRequest(bankStatus){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5305',
        vendorId: appVendorID,
        token: appToken,
        bankStatus
      });
      return request.data;
}
export async function getAccountListRequest(bankRef){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5301',
        vendorId: appVendorID,
        token: appToken,
        bankRef:bankRef
      });
      return request.data;
}
export async function bankPostRequest(bank){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5306',
        vendorId: appVendorID,
        token: appToken,


        bankRef: bank.bankRef,
        bankStatus: bank.bankStatus,
        bankDesc: bank.bankDesc,
        bankId: bank.bankId,
        bankName: bank.bankName,
        bankBic: bank.bankBic,
        bankBlz: bank.bankBlz,
        userName: bank.userName,
        password: bank.password,
        comment: ""


      });
      return request.data;
}


export async function accountsPostRequest(account){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5302',
        vendorId: appVendorID,
        token: appToken,


        bankAccountRef: 0,
        bankAccountStatus: account.bankAccountStatus,
        // bankDesc: account.bankDesc,
        bankId: account.bankId,
        bankRef: account.bankRef,
        bankAccountType: account?.bankAccountType,
        iban: account.iban,
        bankAccountName: account.bankAccountName,
        bankAccountCode: account.bankAccountCode,
        accountNumber:account.accountNumber,
        bankAccountId:account.bankAccountId,
        comment: ""


      });
      return request.data;
}
export async function accessTokenPostRequest(token){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5307',
        vendorId: appVendorID,
        token: appToken,

        accessToken: token.accessToken,
        accessTokenExpire:token.accessTokenExpire,
        accessTokenDate:token.accessTokenDate,
        bankId:token.bankId
      });
      return request.data;
}
export async function connectionPostRequest(data){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5308',
        vendorId: appVendorID,
        token: appToken,

        bankConnectionId: data.bankConnectionId,
        bankConnectionStatus:data.bankConnectionStatus,
        bankId:data.bankId
      });
      return request.data;
}

export async function bankAccountsListRequest(){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5301',
        vendorId: appVendorID,
        token: appToken,

      });
      return request.data;
}



export async function postSlipRequests(model){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5304',
        vendorId: appVendorID,
        token: appToken,
        bankSlipRef: model.bankSlipRef,
        bankSlipStatus: model.bankSlipStatus||1,
        bankSlipName:model.bankSlipName,
        bankAccountRef:model.bankAccountRef,
        beginDate: model.beginDate,
        endDate: model.endDate,
        comment: model.comment||'',
      });
      return request.data;
}

/* 5030: IntraSlipsGetList */
export async function getIntraSlipsRequest(beginDate, endDate, intraSlipStatus){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5030',
        vendorId: appVendorID,
        token: appToken,
        "beginDate": beginDate,
        "endDate": endDate,
        "intraSlipStatus": intraSlipStatus
      });
      return request.data;
}

/* 5031: IntraSlipPost */
export async function postIntraSlipsRequest(intraSlipRef, intraSlipStatus, intraSlipName, intraSlipType, intraSlipYear, intraSlipMonth, comment){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5031',
        vendorId: appVendorID,
        token: appToken,
        "intraSlipRef": intraSlipRef,
        "intraSlipStatus": intraSlipStatus,
        "intraSlipName": intraSlipName,
        "intraSlipType": intraSlipType,      // 1: Import; 2:Export
        "intraSlipYear": intraSlipYear,  //
        "intraSlipMonth": intraSlipMonth,    // 03 : Mart
        "comment": comment //
      });
      return request.data;
}

/* 5032: IntraSlipLinesGetLines */
export async function getIntraSlipLinesRequest(intraSlipRef){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5032',
        vendorId: appVendorID,
        token: appToken,
        "intraSlipRef": intraSlipRef
      });
      return request.data;
}

/* 5035: IntraSlipGetCsv */
export async function getCsvIntraDlipRequest(intraSlipRef){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5035',
        vendorId: appVendorID,
        token: appToken,
        "intraSlipRef": intraSlipRef
      });
      return request.data;
}

export async function intraSlipFromServerRequest(intra){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post("https://edi.mobiapi.de/intra-export", {
        vendorId: appVendorID,
        token: appToken,
        intraSlipRef: intra?.intraSlipRef,

      },
      {
        responseType: "json"
    });
      return request.data;
}

export async function intraDownloadServerRequests(intra){
  var appVendorID = getVendorId();
  var response = await  axios.post("https://edi.mobiapi.de/intra-download",{
    vendorId: appVendorID,
    "intraKey": intra.intraSlipKey
  },
  {
    responseType: "blob" // Cevabı blob olarak al
});
  return response;
}

export async function getBankSlipRequests(beginDate, endDate,bankSlipStatus){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5303',
        vendorId: appVendorID,
        token: appToken,
        beginDate: beginDate,
        endDate: endDate,
        bankSlipStatus: bankSlipStatus,
      });
      return request.data;
}

export async function getSlipLinesListRequest(bankSlipRef){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5311',
        vendorId: appVendorID,
        token: appToken,
        bankSlipRef:bankSlipRef
      });
      return request.data;
}


export async function postSlipLinesRequests(model){
  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5312',
        vendorId: appVendorID,
        token: appToken,
        bankSlipRef: model.bankSlipRef,
        bankSlipLineRef:model.bankSlipLineRef,
        bankSlipLineStatus: model.bankSlipLineStatus||1,
        bankTransactionId:model.bankTransactionId,
        bankSlipLineType:model.bankSlipLineType,
        moduleNr: model.moduleNr,
        sign: model.sign,
        lineTotal: model.lineTotal,
        lineDescription: model.lineDescription,
        erpClientRef: model.erpClientRef,
        generalLedgerAccount:model.generalLedgerAccount,
        counterpartName:model.counterpartName,
        counterpartIban:model.counterpartIban,
        counterpartBlz:model.counterpartBlz,
        counterpartBic:model.counterpartBic,
        counterpartBankName:model.counterpartBankName,
        valueDate:model.valueDate,
        bookingDate:model.bookingDate,
        currency:model.currency,
        comment: model.comment||'',
      });
      return request.data;
}
//sevkiyat takip
export async function getShipmentLinesRequsts(beginDate, endDate, orderType){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5361',
        vendorId: appVendorID,
        token: appToken,
        beginDate: beginDate,
        endDate: endDate,
        pickListType: orderType
      });
      return request.data;
}

export async function getShipmentDetailRequsts(erpOrderRef){

  var appToken = getAppToken();
  var appVendorID = getVendorId();
  var request = await  axios.post(apiUrl, {
        serviceId: '5362',
        vendorId: appVendorID,
        token: appToken,
        erpOrderRef: erpOrderRef
      });
      return request.data;
}
//lojistik api

//shipcloud
//post adress
export async function postAdresses(
    firstName: string,
    lastName: string,
    company: string,
    street: string,
    streetNo: string,
    zipCode: string,
    city: string,
    countryCode: string
  ) {
    const apiKey = "1ce71f551a155ac518c9f5b51195e95a"; 
  
    var response = await axios.post(
      "https://api.shipcloud.io/v1/addresses",
      {
        first_name: firstName,
        last_name: lastName,
        company: company,
        street: street,
        street_no: streetNo,
        zip_code: zipCode,
        city: city,
        country: countryCode,
      },
      {
        auth: {
          username: apiKey,
          password: "", 
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  
    return response.data;
  }

  // post shipment
  export async function createShipment(
    from: {
      firstName: string;
      lastName: string;
      company: string;
      street: string;
      streetNo: string;
      zipCode: string;
      city: string;
      countryCode: string;
    },
    to: {
      firstName: string;
      lastName: string;
      company: string;
      street: string;
      streetNo: string;
      zipCode: string;
      city: string;
      countryCode: string;
    },
    pkg: {
      weight: number;
      length: number;
      width: number;
      height: number;
    },
    carrier: string = "dhl",
    service: string = "standard",
    createLabel: boolean = true
  ) {
    const apiKey = "1ce71f551a155ac518c9f5b51195e95a"; 
  
    const response = await axios.post(
      "https://api.shipcloud.io/v1/shipments",
      {
        from: {
          first_name: from.firstName,
          last_name: from.lastName,
          company: from.company,
          street: from.street,
          street_no: from.streetNo,
          city: from.city,
          zip_code: from.zipCode,
          country: from.countryCode,
        },
        to: {
          first_name: to.firstName,
          last_name: to.lastName,
          company: to.company,
          street: to.street,
          street_no: to.streetNo,
          city: to.city,
          zip_code: to.zipCode,
          country: to.countryCode,
        },
        package: {
          weight: pkg.weight,
          length: pkg.length,
          width: pkg.width,
          height: pkg.height,
        },
        carrier,
        service,
        create_shipping_label: createLabel,
      },
      {
        auth: {
          username: apiKey,
          password: "",
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  
    return response.data;
  }